// src/app/routes/PublicRoute.tsx
import React from 'react';

interface PublicRouteProps {
  element: React.JSX.Element;
}

/**
 * Публичный маршрут без каких-либо проверок:
 * страница доступна всем, независимо от авторизации.
 */
const PublicRoute: React.FC<PublicRouteProps> = ({ element }) => <>{element}</>;

export default PublicRoute;
